<template>
  <v-dialog v-model="open" persistent max-width="480">
    <v-card>
      <v-toolbar color="primary" dark class="pl-6">
        <div class="text-h6 text-center">
          Trocar Tipo de Ingresso
        </div>
      </v-toolbar>

      <v-card-text>
        <v-alert variant="tonal" color="warning" class="mb-4">
          Atenção, o valor final da compra não será alterado, apenas o tipo de ingresso. Caso o novo tipo tenha um valor diferente do atual, a diferença será dada como perdida.
        </v-alert>

        <p class="mb-4">
          Ingresso atual: <strong>{{ item.type }}</strong> ({{ item.sector }} / {{ item.section }})
        </p>

        <v-select
          v-model="selectedTypeId"
          label="Novo tipo de ingresso"
          :items="availableTypes"
          item-value="id"
          item-title="name"
          variant="outlined"
          density="compact"
          :loading="loadingTypes"
          hide-details
        >
          <template #item="{ item: inner, props }">
            <v-list-item
              v-bind="props"
              :title="inner.raw.name"
              :subtitle="`${inner.raw.sector_name} / ${inner.raw.section_name}`"
            />
          </template>
        </v-select>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red darken-1"
          variant="text"
          :disabled="loader.loading"
          @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          variant="text"
          :disabled="!selectedTypeId || loader.loading"
          @click="submit"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
      <v-progress-linear v-show="loader.loading" indeterminate color="primary" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import EventService from '@/services/EventService'
import OrderService from '@/services/OrderService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import OrderItem from '@/types/OrderItem'
import TicketType from '@/types/TicketType'
import { onMounted, ref } from 'vue'

const loader = useLoader()
const snackbar = useSnackBar()

const emit = defineEmits<{ close: [] }>()

const { item, eventId } = defineProps<{ item: OrderItem, eventId: string }>()

const open = ref(true)
const selectedTypeId = ref<string>()
const availableTypes = ref<TicketType[]>([])
const loadingTypes = ref(false)

onMounted(async () => {
  try {
    loadingTypes.value = true
    const { data } = await new EventService().types(eventId)
    availableTypes.value = data.filter(type => type.id !== item.passport?.ticket_type_id)
  } catch {
    snackbar.show('Erro ao buscar tipos de ingresso', 'error')
  } finally {
    loadingTypes.value = false
  }
})

function cancel() {
  open.value = false
  emit('close')
}

async function submit() {
  if (!selectedTypeId.value) return

  try {
    loader.increment()

    const response = await new OrderService().changeType(item.id, selectedTypeId.value)

    Object.assign(item, response.data.data)

    snackbar.show('Tipo de ingresso alterado com sucesso', 'success')

    open.value = false
    emit('close')
  } finally {
    loader.decrement()
  }
}
</script>
